import { c as _c } from "react/compiler-runtime";
import { Stack, Typography } from '@mui/material';
import { forwardRef } from 'react';
export const Tag = forwardRef<HTMLDivElement, {
  icon?: string;
  content: string;
  variant?: 'primary' | 'secondary' | 'success' | 'error';
  disabled?: boolean;
  noWrap?: boolean;
  onRemove?: () => void;
}>((t0, ref) => {
  const $ = _c(36);
  let content;
  let icon;
  let onRemove;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      icon,
      content,
      variant: t1,
      disabled: t2,
      noWrap: t3,
      onRemove,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = content;
    $[2] = icon;
    $[3] = onRemove;
    $[4] = rest;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    content = $[1];
    icon = $[2];
    onRemove = $[3];
    rest = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
  }
  const variant = t1 === undefined ? "primary" : t1;
  const disabled = t2 === undefined ? false : t2;
  const noWrap = t3 === undefined ? false : t3;
  const statusColor = disabled || variant === "primary" || variant === "secondary" ? undefined : `var(--mui-palette-${variant}-main)`;
  const t4 = statusColor ?? (variant === "secondary" || disabled ? "var(--mui-palette-text-secondary)" : "var(--mui-palette-text-primary)");
  let t5;
  if ($[8] !== t4) {
    t5 = {
      color: t4,
      fontWeight: "400 !important"
    };
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const typographySx = t5;
  const t6 = noWrap ? 0 : undefined;
  const t7 = noWrap ? "100%" : undefined;
  const t8 = disabled ? "var(--mui-palette-background-disabled)" : "transparent";
  const t9 = disabled ? "transparent" : statusColor ?? (variant === "primary" ? "var(--mui-palette-primary-main)" : "var(--mui-palette-divider)");
  let t10;
  if ($[10] !== t6 || $[11] !== t7 || $[12] !== t8 || $[13] !== t9 || $[14] !== typographySx) {
    t10 = {
      alignItems: "center",
      gap: "4px",
      width: "fit-content",
      minWidth: t6,
      maxWidth: t7,
      ...typographySx,
      backgroundColor: t8,
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: t9
    };
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
    $[14] = typographySx;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== icon) {
    t11 = icon && <i className={icon} />;
    $[16] = icon;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  const t12 = noWrap ? undefined : "break-all";
  const t13 = noWrap ? 0 : undefined;
  let t14;
  if ($[18] !== t12 || $[19] !== t13 || $[20] !== typographySx) {
    t14 = {
      wordBreak: t12,
      minWidth: t13,
      ...typographySx
    };
    $[18] = t12;
    $[19] = t13;
    $[20] = typographySx;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  const t15 = variant === "secondary" ? "body2" : "subtitle2";
  let t16;
  if ($[22] !== content || $[23] !== noWrap || $[24] !== t14 || $[25] !== t15) {
    t16 = <Typography noWrap={noWrap} sx={t14} variant={t15}>{content}</Typography>;
    $[22] = content;
    $[23] = noWrap;
    $[24] = t14;
    $[25] = t15;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== onRemove) {
    t17 = onRemove && <Stack className="cursor-pointer" onClick={event => {
      event.stopPropagation();
      onRemove();
    }} sx={{
      alignItems: "center",
      justifyContent: "center",
      width: "16px",
      height: "16px",
      borderRadius: "4px",
      "&:hover": {
        backgroundColor: "var(--mui-palette-primary-hover)"
      }
    }}><i className="material-symbols-close-small-rounded text-base" /></Stack>;
    $[27] = onRemove;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== ref || $[30] !== rest || $[31] !== t10 || $[32] !== t11 || $[33] !== t16 || $[34] !== t17) {
    t18 = <Stack direction="row" {...rest} ref={ref} className="px-[8px] py-[3px] rounded-[4px] flex-inline vertical-align-middle" sx={t10}>{t11}{t16}{t17}</Stack>;
    $[29] = ref;
    $[30] = rest;
    $[31] = t10;
    $[32] = t11;
    $[33] = t16;
    $[34] = t17;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  return t18;
});